//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import iconList from '../utils/icon.json';
var originList = iconList.map(function (name) {
  return "el-icon-".concat(name);
});
export default {
  inheritAttrs: false,
  props: ['current'],
  data: function data() {
    return {
      iconList: originList,
      active: null,
      key: ''
    };
  },
  watch: {
    key: function key(val) {
      if (val) {
        this.iconList = originList.filter(function (name) {
          return name.indexOf(val) > -1;
        });
      } else {
        this.iconList = originList;
      }
    }
  },
  methods: {
    onOpen: function onOpen() {
      this.active = this.current;
      this.key = '';
    },
    onClose: function onClose() {},
    onSelect: function onSelect(icon) {
      this.active = icon;
      this.$emit('select', icon);
      this.$emit('update:visible', false);
    }
  }
};